import React from 'react';
import '../../../../scss/common/buttons.scss';
const Button = ({
  id,
  inverted = false,
  onClick = null,
  className = '',
  disabled = false,
  children,
  buttonBackgroundColor = null,
  buttonTextColor = null
}) => {
  const onClickButton = e => {
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    onClick: onClickButton,
    className: `${className} button-cms ${inverted ? 'button-inverted' : ''} ${disabled ? 'disabled' : ''}`,
    style: {
      backgroundColor: buttonBackgroundColor ? buttonBackgroundColor : null,
      color: buttonTextColor ? buttonTextColor : null
    }
  }, children);
};
export default Button;